/**
 * Decides who may ask and where the note text comes from; the rules live in
 * functions/functions/ai/service/auditor/logic.js.
 *
 * @typedef {'bulk' | 'checkout'} AuditTrigger
 */

/** @type {Record<string, AuditTrigger>} */
export const AUDIT_TRIGGERS = {
  BULK: 'bulk',
  CHECKOUT: 'checkout',
};

/**
 * Started by the backend itself, so they appear only on stored audits; the callable refuses them.
 *
 * @typedef {'submit'} ServerAuditTrigger
 */

/** @type {Record<string, ServerAuditTrigger>} */
export const SERVER_AUDIT_TRIGGERS = {
  SUBMIT: 'submit',
};
